import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const PAIN_POINTS = ['Llegás a las 19hs fundida del laburo, abrís la heladera y la cerrás por pura fiaca.', 'Tenés la Air Fryer de adorno porque todo te sale seco, crudo o aburrido.', 'Sentís culpa (y dolor en el bolsillo) cada vez que gastás una fortuna en delivery por falta de tiempo.'];
export function PainSection() {
  return <section className="w-full bg-[#fff7f2] py-10 sm:py-16" data-id="element-190" data-mp="2l82i83kfvxkw">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-191" data-mp="2pz2h3ed4cpq1">
        <div className="mx-auto max-w-3xl text-center" data-id="element-192" data-mp="2pzudgrejirhd">
          <p className="text-xs font-black uppercase tracking-[0.18em] text-red-600" data-id="element-193" data-mp="2bag4hkevmc2i">La rutina que te drena</p>
          <h2 className="mt-3 text-3xl font-black leading-tight text-[#0d1f36] sm:text-4xl" data-id="element-194" data-mp="2g8pznv0lpco4">¿Te pasa esto todos los días?</h2>
          <p className="mt-3 text-base text-slate-600 sm:text-lg" data-id="element-195" data-mp="22asysmf46k3n">No es que no sabés cocinar: te falta un sistema simple para resolver la comida sin gastar de más.</p>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-196" data-mp="3rm98l2w66cum">
          {PAIN_POINTS.map((point, index) => <motion.article key={point} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: index * 0.08
        }} className="rounded-2xl border border-red-100 bg-white p-5 shadow-sm" data-id="element-197" data-mp="3nm75qqep7ddr" data-mpi={index}>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-198" data-mp="38u6ofhkbkefm">
                <XIcon className="h-5 w-5 stroke-[3]" data-id="element-199" data-mp="3imcg0q6nstua" />
              </span>
              <p className="mt-4 text-base font-semibold leading-relaxed text-slate-800" data-id="element-200" data-mp="3iofe7xhytta3">{point}</p>
            </motion.article>)}
        </div>

        <p className="mx-auto mt-7 max-w-2xl rounded-xl border-l-4 border-orange-500 bg-white p-4 text-center text-base font-bold text-[#0d1f36] shadow-sm" data-id="element-201" data-mp="2q5i5301hih5y">
          Tu Air Fryer no tiene que ser un adorno: tiene que ahorrarte tiempo, plata y energía desde esta semana.
        </p>
        <p className="mt-7 text-center text-xl font-black leading-tight text-[#0d1f36] sm:text-2xl" data-id="element-202" data-mp="u2wwd3bumtb0">
          Si respondiste que SÍ a al menos una... <span className="text-orange-600" data-id="element-203" data-mp="yuwuqrc9te5h">esto es para vos.</span>
        </p>
      </div>
    </section>;
}